import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ff-pdfviewer',
  templateUrl: './pdfviewer.component.html',
  styleUrls: ['./pdfviewer.component.scss']
})
export class PDFViewerComponent implements OnInit {

  /**
   * Url of the pdf file to show
   */
  @Input() pdfUrl!: string;

  constructor() {
  }

  ngOnInit(): void { }

}
